/* eslint-disable formatjs/no-literal-string-in-jsx */
import { SvgLock04 } from '@bazaar-marketplace/assets/lock-04';
import { SvgTon } from '@bazaar-marketplace/assets/ton';

interface DropBadgesProps {
  totalLockedAmount?: number | string;
  totalLockedPacks?: number;
}

const formatPackCount = (packs: number) => (packs > 9999 ? `9,999+` : packs);

export const DropBadges = ({ totalLockedAmount, totalLockedPacks }: DropBadgesProps) => (
  <div className="flex gap-2 h-[30px] items-start">
    <div className="flex items-center gap-1.5 bg-[#F7E092] rounded-full px-2 py-1">
      <SvgTon className="w-4 h-4 text-gray-900" />
      {totalLockedAmount ? (
        <span className="text-gray-900 text-xs font-bold">{`${Number(totalLockedAmount).toFixed(2)} in pool`}</span>
      ) : null}
    </div>
    <div className="flex items-center gap-1.5 bg-white/20 rounded-full px-2 py-1 backdrop-blur-[25px]">
      <SvgLock04 className="w-4 h-4 text-white" />
      {totalLockedPacks !== undefined ? (
        <span className="text-white text-xs font-bold">{`${formatPackCount(totalLockedPacks)} packs`}</span>
      ) : null}
    </div>
  </div>
);
